import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2, Beaker } from "lucide-react";

export default function ConsumptionEditor({ value = [], onChange }) {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);
  const rows = value || [];
  const update = (i, patch) => onChange(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  const add = () => onChange([...rows, { product_id: products[0]?.id || "", qty: 0 }]);
  const remove = (i) => onChange(rows.filter((_, idx) => idx !== i));

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 space-y-2" data-testid="consumption-editor">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-slate-600 flex items-center gap-1.5"><Beaker className="w-3.5 h-3.5 text-emerald-600" /> Consommation produits (par prestation)</span>
        <Button type="button" size="sm" variant="outline" onClick={add} disabled={!products.length} data-testid="btn-add-consumption" className="border-slate-200 h-7"><Plus className="w-3.5 h-3.5 mr-1" />Ajouter</Button>
      </div>
      {!products.length && <p className="text-[11px] text-slate-400">Créez d'abord des produits dans Stock pour définir une consommation.</p>}
      {rows.map((r, i) => {
        const p = products.find((x) => x.id === r.product_id);
        return (
          <div key={i} className="flex items-center gap-2" data-testid="consumption-row">
            <Select value={r.product_id} onValueChange={(v) => update(i, { product_id: v })}>
              <SelectTrigger className="bg-white border-slate-200 h-8 flex-1"><SelectValue placeholder="Produit" /></SelectTrigger>
              <SelectContent className="bg-white border-slate-200 max-h-60">{products.map((x) => <SelectItem key={x.id} value={x.id}>{x.name}</SelectItem>)}</SelectContent>
            </Select>
            <Input type="number" value={r.qty} onChange={(e) => update(i, { qty: Number(e.target.value) })} className="bg-white border-slate-200 h-8 w-24" />
            <span className="text-xs text-slate-400 w-8">{p?.unit || ""}</span>
            <button type="button" onClick={() => remove(i)} className="text-slate-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
          </div>
        );
      })}
    </div>
  );
}
